<script setup lang="ts">
import {ObjectiveWidget} from "@/laboratory/components/dashboard/dashboard";
import {computed, ref} from "vue";
import {Slider} from "@/core/components/ui/slider";
import {Widget} from "@/laboratory/components/dashboard/components/widget";
import InformationTooltip from "@/core/components/tooltips/InformationTooltip.vue";
import {currencyze} from "@/core/filters/Currencyze";

const props = defineProps<{
    widget: ObjectiveWidget
}>();

const rate = ref([props.widget.data.progress]);


const baseReward = computed(() => {
    return props.widget.data.objective_reward.value * (props.widget.data.progress / props.widget.data.max_value);
});

const computedReward = computed(() => {
    const maxRewardValue = props.widget.data.objective_reward.value;

    return maxRewardValue * (rate.value[0] / props.widget.data.max_value);
});

const rewardEvolution = computed(() => {
    return computedReward.value - baseReward.value;
});

const quantityEvolution = computed(() => {
    if (!props.widget.data.data.quantity) {
        return null;
    }

    return (props.widget.data.data.quantity * (rate.value[0] / props.widget.data.progress)) - props.widget.data.data.quantity;
});
</script>

<template>
  <Widget :widget="widget">
    <div class="flex gap-6">
      <div>
        <h3>{{ widget.data.objective_label }}</h3>
        <ul>
          <li>- Votre moyenne : {{ widget.data.progress }}</li>
          <li v-if="widget.data.all_healthcenter_progress">
            - Panel Apodis : {{ widget.data.all_healthcenter_progress }}
          </li>
          <li v-if="widget.data.data.quantity">
            - Ventes totales : {{ widget.data.data.quantity }}
          </li>
          <li>
            - Patients : {{ widget.data.data.consumer_count ?? 0 }}
          </li>
        </ul>
      </div>
      <div class="flex-1">
        <div class="max-w-[300px] w-full flex items-center gap-2">
          <label>0</label>
          <Slider v-model:model-value="rate" :max="widget.data.max_value" :step="0.1">
            <template #thumb>
              <div class="relative top-6 text-sm text-primary -translate-x-1/2">
                {{ rate[0] }}
              </div>
            </template>
          </Slider>
          <label>{{ widget.data.max_value }}</label>
        </div>
      </div>
      <div>
        <h2>
          {{ widget.data.objective_reward.label }}
          <InformationTooltip v-if="widget.data.objective_reward.description" class="w-4 h-4">
            {{ widget.data.objective_reward.description }}
          </InformationTooltip>
        </h2>
        <h1>{{ currencyze(computedReward) }}</h1>
        <p>Évolution CA : {{ currencyze(rewardEvolution) }}</p>
        <p v-if="quantityEvolution !== null">
          Evolution quantité : {{ quantityEvolution?.toFixed(0) }}
        </p>
      </div>
    </div>
    <p v-if="widget.data.objective" class="mt-4">
      <strong>🎯 Objectif :</strong> {{ widget.data.objective }}
    </p>
  </Widget>
</template>

<style scoped>

</style>
